/* eslint-disable react/prop-types */
import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import './ResourceRow.scss'

const ResourceRow = ({ resource, isRecent }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const goToResource = useCallback(
    () => {
      const { id } = resource

      navigate(
        `/resources/${id}`,
        { state: { resourceId: id } }
      )
    },
    [ navigate, resource ]
  )

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      id='ResourceRow'
      className='card animation-shrink'
      onClick={goToResource}
    >
      <div className='resource-row-info-wrapper'>
        <div className='resource-image-wrapper'>
          {resource.photo ? (
            <img src={resource.photo.file_url} alt={resource.name} />
          ) : (
            <i className='fa fa-paperclip' />
          )}
        </div>
        <p>{resource.title}</p>
      </div>
      {isRecent && (
        <p className='resource-row-updated-text'>
          {t('resources.resourceRow.updatedOn', {
            date: moment(resource.updated_at).format('MM-DD-YYYY'),
          })}
        </p>
      )}
    </div>
  )
}

export default ResourceRow
